
import CompanyType from './company-type.vue'

export default {
  components: {CompanyType},
  props: {
    firstName: {
      type: String,
      default: undefined
    },
    lastName: {
      type: String,
      default: undefined
    },
    position: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    },
    avatar: {
      type: String,
      default: undefined
    },
    company: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    c_name() {
      if (this.name) return this.name
      return `${this.firstName} ${this.lastName}`
    }
  }
}
